import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'antd';
import MenuIcon from './MenuIcon';

const CROLogo = require('assets/images/logo/CRO Logo.png');

const { Item } = Menu;

const SubMenu = ({ dataSource, onMenuItemClick, selectedKeys }) => {
  const handleMenuItemClick = (e) => {
    const { item } = e;
    if (item.props['data-item'].externalHref) return;
    onMenuItemClick(item.props['data-item']);
  };

  const renderMenuItem = (item) => {
    if (!item.visible()) return null;

    if (item.externalHref) {
      return (
        <Item key={item.name} data-item={item} id={`SubMenu-${item.name}`} className="bhp-sub-menu-external">
          <div
            className="bhp-link bhp-link--external"
            onClick={() => window.open(item.externalHref, '_blank')}
            role="button"
            tabIndex={0}
            onKeyPress={() => window.open(item.externalHref, '_blank')}
          >
            <img src={CROLogo} alt={item.displayName} className="bhp-cro-logo" />
            <div className="bhp-text">{item.displayName}</div>
          </div>
        </Item>
      );
    }

    return (
      <Item id={`SubMenu-${item.name}`.replace(/\s+/g, '')} key={item.name} data-item={item}>
        <div className="bhp-link">
          <MenuIcon icon={item.icon} />
          <div className="bhp-text">
            {item.displayName}
          </div>
        </div>
      </Item>
    );
  };

  return (
    <div className="bhp-sub-menu">
      <Menu mode="horizontal" onClick={handleMenuItemClick} selectedKeys={selectedKeys}>
        {dataSource.map(renderMenuItem)}
      </Menu>
    </div>
  );
};

SubMenu.propTypes = {
  dataSource: PropTypes.array,
  selectedKeys: PropTypes.array,
  onMenuItemClick: PropTypes.func
};

SubMenu.defaultProps = {
  dataSource: [],
  selectedKeys: [],
  onMenuItemClick() {
  }
};

export default SubMenu;
